import FundInvestmentTypes from './FundInvestmentTypes'

export default FundInvestmentTypes
